

const data = [
    {id: 1, image: require('../../assets/IMG-20230305-WA0035.jpg'), title: 'Phlebotomy', desc: ''},
    {id: 2,  image: require('../../assets/IMG-20230305-WA0036.jpg'), title: 'Microbiology investigations', },
    {id: 3, image: require('../../assets/IMG-20230305-WA0037.jpg'), title: 'Ultrasound scan', },
    {id: 4, image: require('../../assets/IMG-20230305-WA0045.jpg'), title: 'Clinical chemistry investigation', },
    {id: 5, image: require('../../assets/IMG-20230305-WA0041.jpg'), title: 'X-ray', desc: ''},
    {id: 6, image: require('../../assets/IMG-20230305-WA0044.jpg'), title: 'Haematology investigations', },
]

export default data;